import { forwardRef as a } from "react";
import { Button as d } from "../../../../Button/Button.js";
import "../../../../Button/IconButton/IconButton.js";
import "@material-bank/ds-utils";
import "@material-bank/mb-icons";
import "theme-ui";
import "@theme-ui/css";
import "../../../../../lib/css/match-media-context.js";
import { jsx as r } from "theme-ui/jsx-runtime";
import { SelectValue as f } from "../../SelectValue/SelectValue.js";
import { CollapseArrow as x } from "../../../../CollapseArrow/CollapseArrow.js";
const S = a((e, p) => {
  const {
    selectedOption: i,
    open: m,
    placeholder: n,
    children: c,
    getToggleButtonProps: o,
    valueSx: l,
    iconSx: s,
    /* eslint-disable @typescript-eslint/no-unused-vars */
    getInputProps: h,
    /* eslint-enable @typescript-eslint/no-unused-vars */
    ...u
  } = e, t = {
    ref: p,
    endIcon: /* @__PURE__ */ r(x, {
      open: m,
      sx: s
    }),
    ...u
  };
  return /* @__PURE__ */ r(d, {
    ...(o == null ? void 0 : o(t)) ?? t,
    children: c ?? /* @__PURE__ */ r(f, {
      selectedOption: i,
      placeholder: n,
      sx: l
    })
  });
});
S.displayName = "SelectButtonTrigger";
export {
  S as SelectButtonTrigger
};
